import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { IScheduleInfo } from '../../../../ts/models/IScheduleInfo';
import { ISetNameAction } from '../../../../ts/ServerApi/types/actionNames';
import { renameContent } from '../../../actions/spaces/RenameContentAction';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanEditGroup, userCanEditSchedule } from './IEntityActionHelpers';


export const RenameEntityAction: IEntityAction<IContentInfo, ISetNameAction> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (availableActions: ISetNameAction, targetItems: IContentInfo[], state: AppState) =>
      targetItems.length === 1 &&
        ((availableActions && availableActions.setName)
        || userCanEditSchedule(state, targetItems)),
  createReduxAction: (targetItems: IContentInfo[]) => renameContent(targetItems[0])
};

export const RenameScheduleAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[], state: AppState) =>
      targetItems.length === 1 && userCanEditSchedule(state, targetItems),
  createReduxAction: (targetItems: IScheduleInfo[]) => renameContent(targetItems[0] as any)
};

export const RenameGroupAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.Rename,
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (_availableActions: {}, targetItems: IGroupInfo[], state: AppState) =>
      targetItems.length === 1 && userCanEditGroup(state, targetItems),
  createReduxAction: (targetItems: IGroupInfo[]) => renameContent(targetItems[0] as any)
};
